import { createUseStyles } from "react-jss";
export default createUseStyles(function (theme) {
  return {
    container: {
      width: '100%',
      borderRadius: 5,
      border: "1px solid ".concat(theme.palette.grey[8]),
      resize: 'none',
      height: 110,
      padding: 10,
      '&:focus': {
        outline: 'none'
      },
      '&::placeholder': {
        fontSize: 15,
        color: theme.palette.grey[11]
      }
    },
    textAreaError: {
      borderColor: theme.palette.red.light,
      opacity: 1,
      outline: 'none',
      '&:focus': {
        borderColor: theme.palette.red.regular,
        opacity: 1,
        outline: 'none'
      }
    },
    bottomError: {
      marginTop: 3
    }
  };
});